import { useEffect } from 'react';
import { useService } from '~/services/service.base';
import { MediaSearchService } from '~/services/service.media.search';
import { reaction } from 'mobx';
export const useTagsHandler = () => {
    const mediaSearchService = useService(MediaSearchService);
    useEffect(() => {
        return reaction(() => mediaSearchService.tags, tags => {
            mediaSearchService.getMediaItems(undefined, undefined, tags);
        });
    }, [mediaSearchService]);
};
